
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteS as ObiOwnShipRemoteSElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-s.js';
 
 
 

 
 export const ObiOwnShipRemoteS = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-s',
   elementClass: ObiOwnShipRemoteSElement,
   events: {
     
   }
  });
 
 